import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CronogramaProjeto } from "../models/cronograma-projeto.model";
import { BaseService } from "src/app/base/services/base.service";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root',
})

export class CronogramaProjetoService extends BaseService<CronogramaProjeto>{

  constructor(public http: HttpClient) {
    super(http);
  }

  public getEntregaById(id: number): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/entrega/' + id, { headers: this.headers });
  }

  public getPathModule(): string {
    return '/projetos/cronograma';
  }
}